<i18n>
{
    "ru": {
        "write_article": "Начните писать {pageType}...",
        "articles": "статью",
        "news": "новость"
    }
}
</i18n>
<template>
    <div class="user-articles">
        <div
            v-if="showBtn"
            class="user-articles__button-wrapper">
            <button
                class="user-articles__button-review"
                @click="addArticle">
                {{ $t('write_article', { pageType: $t(type) }) }}
            </button>
        </div>

        <ScrollLoader v-if="showArticles"
            class="user-articles__wrapper"
            :is-loading="isLoading"
            @onLoad="load">

            <component :is="component"
                class="posts-list__article"
                v-for="article in listDrafts"
                :draft-id="get(article, 'id', null)"
                :small-description="false"
                :id="getArticleId(article)"
                :key="article.createdAt.replace(/\D/g,'')"
                :name="article.name"
                :description="article.anons"
                :comments="get(article, 'comments.total')"
                :entityType="type"
                :user="user"
                :is-draft="isDraft(article)"
                :is-draft-moderate="isDraftModerate(article)"
                :is-draft-rejected="isDraftRejected(article)"
                :is-draft-auto-publish="isDraftAutoPublish(article)"
                :picture="get(article, 'cover.url')"
                :auto-publish-date="article.autoPublishDate" />

            <component :is="component"
                class="posts-list__article"
                v-for="article in list"
                :small-description="false"
                :entityType="type"
                :id="getArticleId(article)"
                :key="article.createdAt.replace(/\D/g,'')"
                :name="article.name"
                :description="article.anons"
                :user="user"
                :date="article.createdAt"
                :comments="get(article, 'comments.total')"
                :likes="get(article, 'likes.total')"
                :code="article.code"
                :is-draft="isDraft(article)"
                :is-draft-moderate="isDraftModerate(article)"
                :is-draft-rejected="isDraftRejected(article)"
                :is-draft-auto-publish="isDraftAutoPublish(article)"
                :url="article.htmlUrl"
                :picture="get(article, 'cover.url') || get(article, 'picture.url')" />
        </ScrollLoader>

        <BlockEmptyPosts v-else :data-type="type"/>
    </div>
</template>

<script>
import get from 'lodash/get';
import filter from 'lodash/filter'
import throttle from "lodash/throttle";

import BlockUserArticle from "@/components/layout/blocks/BlockUserArticle";
import ScrollLoader from "@/components/ui/ScrollLoader";
import BlockEmptyPosts from "@/components/profile/BlockEmptyPosts";

export default {
    name: 'UserArticlesList',
    components: {
        BlockEmptyPosts,
        ScrollLoader,
        BlockUserArticle
    },
    props: {
        type: {
            type: String,
            default: 'articles'
        },
        component: {
            type: String,
            default: 'BlockUserArticle'
        },
        articles: {
            type: Object,
            default: () => {}
        },
        drafts: {
            type: Object,
            default: () => {}
        },
        user: {
            type: Object,
            default: () => {}
        },
        showBtn: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isLoading: false,
            perPage: 10,
            showPublished: false,
            scrollLoadType: 'drafts',
            list: [],
            listDrafts: [],
            nextPageUrl: null,
            draftsNextPageUrl: null
        }
    },
    computed: {
        showArticles() {
            const listLength = get(this.list, 'length', 0);
            const listDraftsLength = get(this.listDrafts, 'length', 0);

            return listLength > 0 || listDraftsLength > 0;
        },
        updateEventName() {
            return this.type + '-draft-updated'
        }
    },
    watch: {
        articles(value) {
            this.list = get(value, 'items', []);
            this.nextPageUrl = get(this.articles, 'nextPageUrl', null);

        },
        drafts(value) {
            this.listDrafts = get(value, 'items', []);
            this.draftsNextPageUrl = get(this.drafts, 'nextPageUrl', null);

            if(this.postsDrafts && this.postsDrafts.length < 5) {
                this.showPublished = true;
            }
        }
    },
    beforeDestroy() {
        if (this.$bus._events[this.updateEventName])
            this.$bus._events[this.updateEventName] = []
    },
    mounted() {

        // eslint-disable-next-line
        if (process.client) {
            this.$bus.$on(this.updateEventName, draft => {
                if (draft.id) this.replaceDraft(draft)
            })
        }

        this.list = get(this.articles, 'items', []);
        this.nextPageUrl = get(this.articles, 'nextPageUrl', null);

        this.listDrafts = get(this.drafts, 'items', []);
        this.draftsNextPageUrl = get(this.drafts, 'nextPageUrl', null);

        if (this.postsDrafts && this.postsDrafts.length < 5) {
            this.showPublished = true;
        }
    },
    methods: {
        get,
        getArticleId(article) {
            let id = ''

            // Если черновик
            if (!article.htmlUrl) {
                id += 'draft-' + article.id
            } else {
                id += article.code
            }

            return id
        },
        replaceDraft(draft) {
            const anotherDrafts = filter(this.listDrafts, d => d.id !== draft.id)

            let scrollId = '#'

            // Если материал опубликован
            if (draft.htmlUrl) {
                scrollId += draft.code

                this.list = [
                    draft,
                    ...this.list
                ]

                this.listDrafts = anotherDrafts
            } else {
                scrollId += 'draft-' + draft.id

                this.listDrafts = [
                    draft,
                    ...anotherDrafts
                ]
            }

            this.$nextTick(() => {
                this.$scrollTo(scrollId, 750, {
                    offset: this.isDeviceDesktop ? 0 : -48,
                    force: true,
                    lazy: false
                })
            })
        },
        addArticle() {
            this.showPopup('content-editor', {
                type: this.type,
                updateEvent: this.updateEventName
            })
        },
        isDraftRejected(article) {
            return get(article, 'moderation.status', false) === 'rejected'
        },
        isDraftModerate(article) {
            return get(article, 'moderation.status', false) === 'onModeration'
        },
        isDraftAutoPublish(article) {
            return get(article, 'moderation.status', false) === 'autoPublish'
        },
        isDraft(article) {
            return !get(article, 'createdBy', false);
        },
        load: throttle(async function() {
            if(this.isLoading) return;

            if(this.draftsNextPageUrl) {
                this.scrollLoadType = 'drafts';
                this.draftsNextPageUrl = await this.getData(this.draftsNextPageUrl);
            }

            else if(this.nextPageUrl) {
                if(this.showPublished === false) {
                    this.showPublished = true;
                }

                else {
                    this.scrollLoadType = 'published';
                    this.nextPageUrl = await this.getData(this.nextPageUrl);
                }
            }

        }, 1000),
        async getData(pageUrl) {
            if(pageUrl) {
                this.isLoading = true;
                const response = await this.$api.get(pageUrl);

                const entityType = this.type === 'news' ? 'news' : 'article'

                if(get(response, 'data.items', false)){
                    await this.$emit('items-loaded', response.data.items, entityType, true)
                }

                this.read(response.data);

                this.isLoading = false;
                return get(response.data, 'nextPageUrl', null);
            }
        },
        read(list, type) {
            if(this.scrollLoadType === 'drafts') {
                this.listDrafts = [
                    ...this.listDrafts,
                    ...list.items
                ]
            }

            else if(this.scrollLoadType === 'published') {
                this.list = [
                    ...this.list,
                    ...list.items
                ]
            }
        },
    }
}
</script>

<style lang="less">
.user-articles {
    &__wrapper {
        //border-top: rem(1) solid @color-gray-white;
    }

    &__list {
        padding-top: rem(15);
    }
    &__button-wrapper {
        border-bottom: rem(1) solid @color-gray-white;

        padding-top: rem(16);
        padding-bottom: rem(16);

        .page-padding();

        @{desktop} & {
            padding-top: rem(10);
            padding-bottom: rem(20);
            border-bottom: none;
        }
    }

    &__button-review {
        display: flex;
        align-items: center;

        background-color: @color-gray-light-2;
        border: none;
        border-radius: rem(3);
        color: @color-gray;
        font-size: rem(15);

        height: rem(48);
        width: 100%;

        .page-padding();

        @{desktop} & {
            padding-right: @dim-page-padding;
            padding-left: @dim-page-padding;
        }
    }

    .block-user-article {
        border-bottom: rem(1) solid @color-gray-white;

        padding-top: rem(22);
    }
}
</style>
